import { render, staticRenderFns } from "./ProgressOfRequests.vue?vue&type=template&id=4b23b869"
import script from "./ProgressOfRequests.vue?vue&type=script&lang=ts"
export * from "./ProgressOfRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports